import { render, staticRenderFns } from "./afterClass.vue?vue&type=template&id=69885902&scoped=true"
import script from "./afterClass.vue?vue&type=script&lang=js"
export * from "./afterClass.vue?vue&type=script&lang=js"
import style0 from "./afterClass.vue?vue&type=style&index=0&id=69885902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69885902",
  null
  
)

export default component.exports